import { gql } from '@apollo/client'

export const Query = gql`
  query accommodationRoomTypes(
    $companyId: ID!,
    $accommodationId: ID!,
    $filters: AccommodationRoomTypeFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    accommodations(companyId: $companyId, filters: { idEq: $accommodationId }, first: 1) {
      nodes {
        id
        accommodationRoomTypes(filters: $filters, after: $after, before: $before, first: $first, last: $last) {
          nodes {
            id
            capacity
            layout
            name
            notes
          }
          pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
        }
      }
    }
  }
`
